/**
 * Shared formatting utilities for activities and workout segments
 */

// Format duration from seconds to HH:MM:SS or MM:SS
export const formatDuration = (seconds?: number | null): string => {
  if (!seconds) return '--:--';

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }
  return `${minutes}:${secs.toString().padStart(2, '0')}`;
};

// Format time axis (seconds to MM:SS) - rounds to whole seconds
export const formatTimeAxis = (seconds: number): string => {
  const roundedSeconds = Math.round(seconds);
  const minutes = Math.floor(roundedSeconds / 60);
  const secs = roundedSeconds % 60;
  return `${minutes}:${secs.toString().padStart(2, '0')}`;
};

// Format distance axis (meters to km with 1 decimal place)
export const formatDistanceAxis = (meters: number): string => {
  return (meters / 1000).toFixed(1);
};

// Format pace from seconds to min:sec
export const formatPaceValue = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60);
  const secs = Math.round(seconds % 60);
  return `${minutes}:${secs.toString().padStart(2, '0')}`;
};

// Format pace from seconds per km to min:sec/km
export const formatPace = (secondsPerKm?: number | null): string => {
  if (!secondsPerKm) return '--:--';
  return formatPaceValue(secondsPerKm);
};

// Format distance from meters to km
export const formatDistance = (meters?: number | null): string => {
  if (!meters) return '--';
  return (meters / 1000).toFixed(2);
};

// Convert m/s to km/h (for rides)
export const convertToKmh = (mps: number | null): number | null => {
  if (mps === null || mps === undefined) return null;
  return mps * 3.6;
};

// Convert m/s to min/km (for runs) - returns seconds per km
export const convertToMinPerKm = (mps: number | null): number | null => {
  if (mps === null || mps === undefined || mps === 0) return null;
  return 1000 / mps;
};
